import { Head, Link } from "@inertiajs/react";
import { Button } from "@/components/ui/button";

export default function Homepage() {
  return (
    <>
    <Head title="Book meeting rooms with your team" />
    <div className="flex flex-col min-h-screen">
      <header className="pl-4 pr-6 h-16 flex items-center justify-between border-b">
        <span className="font-semibold text-lg">bookd.one</span>
        <nav className="flex items-center gap-4 text-sm">
          <Link href="/sign_in">Sign in</Link>
          <Button asChild size="sm">
            <Link href="/sign_up">Sign up</Link>
          </Button>
        </nav>
      </header>

      <main className="flex flex-1 flex-col items-center justify-center text-center px-6">
        <h1 className="text-4xl font-bold tracking-tight mb-4">
          Book meeting rooms with your team
        </h1>
        <p className="text-muted-foreground mb-8 max-w-sm">
          Simple, fast room reservations — no back-and-forth required.
        </p>
        <div className="flex gap-3">
          <Button asChild>
            <Link href="/sign_up">Get started</Link>
          </Button>
          <Button asChild variant="outline">
            <Link href="/sign_in">Sign in</Link>
          </Button>
        </div>
      </main>
    </div>
    </>
  );
}
